import type { TaskTodo } from './cronoTaskTodo';
import type { SequenceInstanceStatus } from './enums/sequenceInstanceStatus';
import type { Prospect } from './prospect';
import { RewriteStatus } from './enums/rewriteStatus';
import { RewriteError } from './enums/rewriteError';

export interface SequenceInstance {
  id: number;
  subscriptionId: number;
  userId: number;
  //Relative to the current user, so false for a manager acting on behalf of the owner
  owned: boolean;
  //Full name of the sequence instance owner
  user: string | null;
  //The same owner, split, because template variables resolve first and last
  //name separately and a full name cannot be split back apart reliably
  userFirstName?: string | null;
  userLastName?: string | null;
  strategyId: number;
  accountId: string | null;
  prospectId: string | null;
  actualStep: number;
  numberOfSteps: number;
  startDate?: string;
  endDate?: string;
  lastStepDate?: string;
  active: boolean;
  tasks: TaskTodo[];
  name?: string | null;
  prospect?: Prospect;
  isPersonalized: boolean;
  rewriteStatus?: RewriteStatus | null;
  rewriteError?: RewriteError | null;

  status: SequenceInstanceStatus | null;
  selectedEmail?: string | null;
  strategyName?: string | null; // present only during useSearchProspectsInfiniteScroll
  ageInDays?: number; // whole days in sequence: (endDate ?? now) - startDate. Populated only by /Strategy/Details
}

export const isComplete = (sequenceInstance: SequenceInstance) => {
  return sequenceInstance.actualStep === sequenceInstance.numberOfSteps;
};
